module.exports = __webpack_public_path__ + "img/logo_mini.e20de3e0.png";